/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:56:17
 *
 * LastModified: 2017-06-01 17:12:42
 *-------------------------------------------------------*/

import { take, call, put, fork, all } from 'redux-saga/effects'
import fetchApi from '../../../../../utils/fetchApi'

function* getAllGroupFlow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { filter, clearState },
      next
    } = yield take('GET_ALL_GLASSES_GROUP')
    if (clearState) {
      yield put({ type: 'RESET_ALL_GLASSES_STATE' })
    }
    try {
      const response = yield call(fetchApi, `Groups?filter=${JSON.stringify(filter)}`)
      if (response && !response.error) {
        yield put({ type: 'GET_ALL_GLASSES_GROUP_SUCCESS', payload: response })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* deleteGroupFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('DELETE_GLASSES_GROUP')
    try {
      const { id } = payload
      // Delete document in database
      yield call(fetchApi, `Groups/${id}`, {}, { method: 'DELETE' })
      if (next && typeof next === 'function') {
        next()
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* updateAllGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload, next } = yield take('UPDATE_ALL_GROUP');
    try {
      const reqs = [];
      payload.forEach(el => {
        const data = el;
        const groupId = data.groupId;
        delete data.groupId;
        reqs.push(call(fetchApi, `Groups/${groupId}`, data, { method: 'PATCH' }));
      });

      const responses = yield all(reqs);
      if (responses && responses[0] && !responses[0].error) {
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* exportAllGroupGlassesFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { filter, sortBy = 'latest' }, next } = yield take('EXPORT_ALL_GROUP_GLASSES');
    try {
      const response = yield call(fetchApi, `Groups?filter=${JSON.stringify(filter)}&sortBy=${sortBy}`);
      if (response && !response.error) {
        if (next && typeof next === 'function') {
          next(response);
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

export default function* glassesGroupFlow() {
  yield fork(getAllGroupFlow)
  yield fork(updateAllGlassesFlow)
  yield fork(deleteGroupFlow)
  yield fork(exportAllGroupGlassesFlow)
}



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-group/saga/index.js